export const REVIEW_PAGE_SECTIONS = {
  AMENITIES: 'AMENITIES',
  RENT_DETAILS: 'RENT_DETAILS',
  CONTACT: 'CONTACT',
  MEDIA: 'MEDIA',
  PROPERTY_INFORMATION: 'PROPERTY_INFORMATION',
  SCREENING_CRITERIA: 'SCREENING_CRITERIA',
  // MF Specific
  BUILDING_DETAILS: 'BUILDING_DETAILS',
  COSTS_AND_FEES: 'COSTS_AND_FEES',
  FLOOR_PLANS: 'FLOOR_PLANS',
  KEY_FEATURES: 'KEY_FEATURES',
  OTHER_PROPERTY_FEATURES: 'OTHER_PROPERTY_FEATURES',
  POLICIES_AND_TERMS: 'POLICIES_AND_TERMS',
  SPECIAL_OFFERS: 'SPECIAL_OFFERS',
} as const;

export const RECS_TO_MF_SECTION_MAP: Record<string, string> = {
  description: REVIEW_PAGE_SECTIONS.BUILDING_DETAILS,
  leaseTerms: REVIEW_PAGE_SECTIONS.BUILDING_DETAILS,
  website: REVIEW_PAGE_SECTIONS.BUILDING_DETAILS,
  businessHours: REVIEW_PAGE_SECTIONS.BUILDING_DETAILS,
  photos: REVIEW_PAGE_SECTIONS.MEDIA,
  virtualTour: REVIEW_PAGE_SECTIONS.MEDIA,
  video: REVIEW_PAGE_SECTIONS.MEDIA,
  price: REVIEW_PAGE_SECTIONS.FLOOR_PLANS,
  floorPlanLayout: REVIEW_PAGE_SECTIONS.FLOOR_PLANS,
  squareFootage: REVIEW_PAGE_SECTIONS.FLOOR_PLANS,
  unitAvailability: REVIEW_PAGE_SECTIONS.FLOOR_PLANS,
  floorPlanPhotos: REVIEW_PAGE_SECTIONS.FLOOR_PLANS,
  dateAvailable: REVIEW_PAGE_SECTIONS.FLOOR_PLANS,
  specialOffer: REVIEW_PAGE_SECTIONS.SPECIAL_OFFERS,
  amenities: REVIEW_PAGE_SECTIONS.OTHER_PROPERTY_FEATURES,
  laundry: REVIEW_PAGE_SECTIONS.KEY_FEATURES,
  leaseLength: REVIEW_PAGE_SECTIONS.POLICIES_AND_TERMS,
  parking: REVIEW_PAGE_SECTIONS.POLICIES_AND_TERMS,
  contact: REVIEW_PAGE_SECTIONS.CONTACT,
  oneTimeFee: REVIEW_PAGE_SECTIONS.COSTS_AND_FEES,
  monthlyFee: REVIEW_PAGE_SECTIONS.COSTS_AND_FEES,
  petsNotAllowed: REVIEW_PAGE_SECTIONS.SCREENING_CRITERIA,
};
